import React from 'react';
import { useRouteMatch, useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { goToTop } from '_helpers';
import { _ } from '_locales';
import HOC from '_HOC';

const Container = styled.div`
  margin-bottom: 100px;
  margin-top: 60px;
  padding: 0 15px;
  box-sizing: border-box;
`;

const Title = styled.h1`
  font-size: 20px !important;
   
  font-weight: 500 !important;
  margin-bottom: 50px;
`;

const Holder = styled.div`
  justify-content: center;
  margin: auto;
  text-align: center;
   

  a {
    outline: none;
    text-decoration: none !important;

    &:hover {
      text-decoration: none !important;
    }
  }
`;

const TypeHolder = styled.button`
  font-family: Roboto, sans-serif !important;
  background: none;
  border: none;
  margin: 15px 12px;
  border-radius: 4px;
  width: 281px;
  min-height: 145px;

  cursor: pointer;
  a {
    text-decoration: none !important;
  }

  &:focus {
    outline: 2px solid black;
  }
`;

const InnerTypeHolder = styled.span`
  all: initial;
  font-family: Roboto, sans-serif !important;
  display: block;
  cursor: pointer;
  text-align: center;
`;

const HelpText = styled.p`
  margin-top: 5px;
  margin-bottom: 10px;
  color: #7A7175;
  padding: 4px 8px;
  font-weight: 500 !important;
  font-size: 16px !important;
  line-height: 1.5em;
`;

const ReminderTypeTitle = styled.h2`
  font-size: 18px !important;
  text-transform: capitalize;
`;

const Icon = styled.img`
  height: 60px;
  /* width: 64px; */
  margin: 5px 5px 10px 5px;
`;

const Reminder = () => {
  const match = useRouteMatch();
  const history = useHistory();

  const clickHandler = (target) => {
    goToTop();
    history.push(`${match.url}/${target}`);
  };

  return (
    <Container>
      <Title style={{ textAlign: 'center' }}>
        {_('reminder.select_the_type_of_reminder')}
      </Title>
      <Holder>
        {/* Weekly Reminder */}

        <TypeHolder
          onClick={() => clickHandler('weekly')}
          aria-label="Set weekly reminder"
        >
          <InnerTypeHolder>
            <Icon src={`${process.env.PUBLIC_URL}/images/reminder/weekly.svg`} alt="weekly reminder" />
            <ReminderTypeTitle>
              {_('reminder.weekly_summary')}
            </ReminderTypeTitle>
            <HelpText>
              {_('reminder.weekly_reminder_that_lists')}
            </HelpText>
          </InnerTypeHolder>
        </TypeHolder>

        {/* Single Reminder */}
        <TypeHolder
          onClick={() => clickHandler('single')}
          aria-label="Set reminder for a specific collection type or event"
        >
          <InnerTypeHolder>
            <Icon src={`${process.env.PUBLIC_URL}/images/reminder/single.svg`} alt="single reminder" />
            <ReminderTypeTitle>
              {_('reminder.single_collection_or_event')}
            </ReminderTypeTitle>
            <HelpText>{_('reminder.get_reminders_for_a_specific_collection_type')}</HelpText>
          </InnerTypeHolder>
        </TypeHolder>

      </Holder>
    </Container>
  );
};

export default HOC(Reminder);
